import { gql } from '@apollo/client'

export const CREATE_COMPANY_MUTATION = gql`
  mutation createCompany($attributes: CompanyInput!) {
    createCompany(attributes: $attributes) {
      id
      title
    }
  }
`
